import EstimateGateway from "@/usecases/orders/estimate-gateway";
import ClientLike from "../client-like";
import Estimate from "@/usecases/orders/estimate";
import SaveEstimateRequest from "@/usecases/orders/save-estimate-request";
import statusTranslater from "@/usecases/orders/estimate-status-translater";

export default class EstimateApi implements EstimateGateway {
  public constructor(private client: ClientLike) {}

  public async find(id: number): Promise<Estimate | undefined> {
    const param = {
      id,
      action: "show",
      estimateTree: 1,
      orderNew: 1
    };
    return await this.findEstimate(param);
  }

  public async findEstimateWithoutTree(
    id: number
  ): Promise<Estimate | undefined> {
    const param = {
      id,
      action: "show",
      orderNew: 1
    };
    return await this.findEstimate(param);
  }

  private async findEstimate(param: any): Promise<Estimate | undefined> {
    const res = await this.client.get("get_estimate.php", param);
    if (res.estimates.length > 0) {
      return toEstimate(res.estimates[0]);
    }
  }

  public async findAll(
    options: {
      projectId?: string;
      projectName?: string;
      estimateTree?: number;
    } = {}
  ): Promise<Estimate[]> {
    const res = await this.client.get("get_estimate.php", options);
    return res.estimates.map(toEstimate);
  }

  public async save(estimate: SaveEstimateRequest): Promise<number> {
    const data = await this.client.post("save_estimate.php", estimate);
    return data.id;
  }

  public async copy(estimateId: number): Promise<number> {
    const data = await this.client.post("copy_estimate.php", {
      id: estimateId
    });
    return data.id;
  }

  public async create(projectId: number): Promise<number> {
    let newEstimate = new Estimate();
    newEstimate.projectId = projectId;
    newEstimate.createOrderNew = true;
    return await this.save(newEstimate);
  }

  public async destroy(id: number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_estimate.php", d);
  }

  public async csvDownload(id: number): Promise<string> {
    const d = new FormData();
    d.append("id", String(id));
    const res = await this.client.post("create_estimate_csv.php", d);
    return res.file;
  }

  public async updateEstimateList(estimates: Estimate[]) {
    await this.client.post("save_estimate_list.php", {
      estimates: estimates
    });
  }

  public async updateActualResult(
    projectId: number,
    estimateId: number
  ): Promise<void> {
    await this.client.post("update_actual_result.php", {
      projectId: projectId,
      estimateId: estimateId
    });
  }
}

function toEstimate(estimate: any): Estimate {
  return {
    ...estimate,
    statusName: statusTranslater.toJp(estimate.status)
  };
}
